import { FC } from 'react';
import NullResultsMessage from '../';
import { NullContainer } from '../styles';

interface NullResultsNewestListingsProps {
  header: string;
  bodyText: string;
}

const NullResultsNewestListings: FC<NullResultsNewestListingsProps> = ({ header, bodyText }) => {
  return (
    <NullContainer>
      <NullResultsMessage header={header} bodyText={bodyText} />
    </NullContainer>
  );
};

export default NullResultsNewestListings;
